import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../lib/custom-scrollbar/custom-scrollbar';
import OEResizeObserver from '../../../lib/components/oe-resize-observer';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEIconButton} from '../../elements/controls/oe-button';

export default class OEOverlayTextBox extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.unitSize = 16;

        this.state = {
            style: null
        };

        this.onWindowResized = this.onWindowResized.bind(this);

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.onUnitSizeResize = this.onUnitSizeResize.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onIFrameRef = this.onIFrameRef.bind(this);
        
        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
        this.onToLeftRightBtnPressed = this.onToLeftRightBtnPressed.bind(this);
    }

    componentWillUnmount()  {
        this.setCompId(null);
    }

    onWindowResized()   {
        this.updateStyle();
    }

    onConnect()  {}

    onRelease()  {}

    setCompId(id)   {
        if(this.compId == id || !this.oe.isReady())   return;
        let highlight = this.oe.sharedInterface.getUIControllerHighlightingTooltip();

        if(this.compId) highlight.removeCustomHighlightedComponent(this.compId);
        this.compId = id;
        if(this.compId) highlight.addCustomHighlightedComponent(this.compId);
    }

    updateStyle()   {
        if(!this.$iFrameDocumentBody)    return;
        let style = {height: this.$iFrameDocumentBody.innerHeight()};
        this.setState({style: style});
    }

    updateIFrameBodyFontSize()  {
        if(!this.$iFrameDocumentBody || !this.props.transferFontSize)   return;
        this.$iFrameDocumentBody.css({'fontSize': this.unitSize.toString() + 'px'});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setCompId(null);
            this.setState({src: '', style: null});
            return;
        }

        this.setCompId(null);
    }

    onMouseEnter(e) {
        this.setCompId(e.target.dataset.id);
    }

    onMouseLeave(e) {
        if(this.compId == e.target.dataset.id)  this.setCompId(null);
    }

    onLoad()    {
        if(!this.iFrameRef || !this.iFrameRef.contentWindow)    return;
        this.iFrameDocument = this.iFrameRef.contentWindow.document;

        let host = window.location.host;
        let path = window.location.pathname;
        let url = 'http://' + host + path;

        let cssFiles = [
            'fonts/effigos-symbol.css',
            'fonts/roboto/roboto.css'
        ];

        cssFiles.forEach(path => {
            let cssLink = document.createElement('link');
            cssLink.rel = 'stylesheet';
            cssLink.type = 'text/css';
            cssLink.href = url + path;
            document.head.appendChild(cssLink);
        });

        $(this.iFrameDocument.documentElement).find('span.comp-ref').hover(this.onMouseEnter, this.onMouseLeave);
        this.$iFrameDocumentBody = $(this.iFrameDocument.documentElement).find('body');

        this.updateStyle();
        this.updateIFrameBodyFontSize();
    }

    onUnitSizeResize(sender, size)  {
        if(this.unitSize === size.w) return;
        this.unitSize = size.w;
        this.updateIFrameBodyFontSize();
    }

    onResize() {
        this.updateStyle();
    }

    onIFrameRef(ref)   {
        if(this.iFrameRef === ref) return;
        this.iFrameRef = ref;
        if(!ref && this.iFrameDocument)    {
            $(this.iFrameDocument.documentElement).find('span.comp-ref').off('mouseenter mouseleave');
            this.iFrameDocument = null;
            this.$iFrameDocumentBody = null;
        }
    }

    render() {
        const LayoutType = OEOverlayTextBox.ExtLayoutType;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className={'overlay-text-box ' + this.props.extLayoutType + (this.props.isOpen ? ' isOpen ' : ' ') + (this.props.isHidden ? ' isHidden ' : ' ') + this.props.className}>
                    
                    <OEResizeObserver className="unit-size-observer" onResize={this.onUnitSizeResize}/>
                    <OEResizeObserver onResize={this.onResize}/>

                    <CustomScrollbar
                        horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                        verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                    >
                        <iframe
                            style={this.state.style}
                            src={this.props.src}
                            ref={this.onIFrameRef}
                            onLoad={this.onLoad}
                        />
                    </CustomScrollbar>

                    <OEIconButton
                        className={'btn ' + this.props.extLayoutType + ' top-btn close-btn'}
                        icon={OEIconCodes.overlayTextBox.textBoxClose}
                        onPressed={this.onCloseBtnPressed}
                    />

                    <OEIconButton
                        className={'btn ' + (this.props.extLayoutType === LayoutType.right ? LayoutType.left : LayoutType.right) + ' top-btn'}
                        icon={this.props.extLayoutType === LayoutType.right ? OEIconCodes.overlayTextBox.textBoxToLeft : OEIconCodes.overlayTextBox.textBoxToRight}
                        onPressed={this.onToLeftRightBtnPressed}
                    />
                </div>

            </React.Fragment>
        );
    }

    onCloseBtnPressed()   {
        if(this.props.onToggle) this.props.onToggle();
    }

    onToLeftRightBtnPressed()   {
        const LayoutType = OEOverlayTextBox.ExtLayoutType;
        if(this.props.onToLeftRightBtnPressed) this.props.onToLeftRightBtnPressed(this.props.extLayoutType === LayoutType.right ? LayoutType.left : LayoutType.right);
    }
}

OEOverlayTextBox.ExtLayoutType = {
    right: 'right',
    left: 'left'
};

OEOverlayTextBox.defaultProps = {
    className: '',
    moduleId: '',
    isOpen: true,
    isHidden: false,
    extLayoutType: OEOverlayTextBox.ExtLayoutType.right
};

OEOverlayTextBox.propTypes = {
    className: PropTypes.string,
    moduleId: PropTypes.string,
    isOpen: PropTypes.bool,
    isHidden: PropTypes.bool,
    extLayoutType: PropTypes.oneOf([OEOverlayTextBox.ExtLayoutType.right, OEOverlayTextBox.ExtLayoutType.left]),
    src: PropTypes.string,
    onToggle: PropTypes.func,
    onToLeftRightBtnPressed: PropTypes.func
};